import React, { FC, useState, ComponentProps } from 'react'
import { LeadgenPopup } from './LeadgenPopup'
import { PostLeadPopup } from './PostLeadPopup'

export type { LeadgenFormData } from './LeadgenPopup'

export enum LeadgenPopupType {
  MEDADV = 'MEDADV',
  PDP = 'PDP',
  MEDSUP = 'MEDSUP',
  LIFE_INSURANCE = 'LIFE_INSURANCE',
  AUTO_INSURANCE = 'AUTO_INSURANCE',
  GUARANTEED_ISSUE = 'GUARANTEED_ISSUE',
  DISABILITY = 'DISABILITY',
  QUIZ = 'QUIZ',
  SCHEDULE_AEP = 'SCHEDULE_AEP'
}

type Props = ComponentProps<typeof LeadgenPopup> & {
  flow: LeadgenPopupType
  industryType?: IndustryType
  customerId?: string
  consultationDate?: string
  bestTimeToCall?: 'morning' | 'afternoon/evening'
  email?: string
  addressZip?: string
  age?: string
}

export const LeadgenPopupFlow: FC<Props> = ({
  flow,
  industryType,
  customerId,
  consultationDate,
  bestTimeToCall,
  email,
  addressZip,
  age,
  ...props
}) => {

  const [showLeadgen, setShowLeadgen] = useState<boolean>(true)
  const [showPostLeadgen, setShowPostLeadgen] = useState<boolean>(false)

  const handleLeadgenSubmit = (answers: Record<string, any>): Promise<boolean> => {
    const promise = props.onSubmit(answers, flow)

    promise.then((continueFlow: boolean) => {
      if (continueFlow) {
        setTimeout(() => {
          setShowLeadgen(false)
        }, 700)
        setTimeout(() => {
          setShowPostLeadgen(true)
        }, 300)
      }
    })

    return promise
  }

  const handleLeadgenClose = () => {
    if (!showPostLeadgen) {
      props.onClose()
    }
    setShowLeadgen(false)
  }

  return (
    <div>
      {showLeadgen && (
        <LeadgenPopup
          {...props}
          onSubmit={handleLeadgenSubmit}
          onClose={handleLeadgenClose}
          expandTitle={props.expandTitle || flow === 'MEDADV'}
        />
      )}

      {showPostLeadgen && (
        <PostLeadPopup
          {...props}
          industryType={industryType}
          onClose={props.onClose}
          small={flow === 'MEDADV'}
          leadType={flow}
          customerId={customerId}
          consultationDate={consultationDate}
          bestTimeToCall={bestTimeToCall}
        />
      )}
    </div>
  )
}
